import {
	AppBar,
	Dialog,
	Menu,
	MenuItem,
	Toolbar,
	WithStyles,
} from '@material-ui/core';
import blueGrey from '@material-ui/core/colors/blueGrey';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ICellSubCareer } from 'src/actions/skill';
import CertificationFileUpload from 'src/containers/CertificationFileUpload';
import { UpwardTransition } from 'src/utils';
import { Routes, Screens } from 'src/utils/Routes';
import ReactTable, {
	RowInfo,
	RowRenderProps,
} from '../components/MyReactTable';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import Config from '../site.config.json';
import MessageDialog from './MessageDialog';
const ITEM_HEIGHT = 48;
const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		dialog: {
			width: '55%',
		},
		menuButton: {
			height: '32px',
			width: '32px',
		},
		paper: {
			margin: theme.spacing(2),
			padding: theme.spacing(2),
		},
		selectedRow: {
			background: `${theme.palette.secondary.light} !important`,
			color: `${theme.palette.secondary.contrastText} !important`,
		},
		subComponent: {
			borderLeftColor: blueGrey[100],
			borderLeftStyle: 'solid',
			borderLeftWidth: theme.spacing(1),
			marginBottom: theme.spacing(2),
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			paddingLeft: theme.spacing(1),
		},

		scrollPaper: {
			alignItems: 'flex-start',
		},

		rowDarkColor: {
			'&:hover': {
				backgroundColor: '#FFD6DA !important',
			},
			backgroundColor: '#FFE1E4 !important',
		},
		rowLightColor: {
			'&:hover': {
				backgroundColor: '#FFD6DA !important',
			},
			backgroundColor: 'rgba(255,214,218,0.93) !important',
		},
	});

interface IState {
	functionMenus?: JSX.Element;
	certificationUploadDialog: boolean;
	careerID: string;
	classID: string;
	dialogOpen: boolean;
	dialogMessage: string;
	reasonCode: string;
	seq: string;
}

class ProcessStatusSubTable extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);
		this.state = {
			careerID: '',
			certificationUploadDialog: false,
			classID: '',
			dialogMessage: '',
			dialogOpen: false,
			reasonCode: '',
			seq: '',
		};
	}

	public render() {
		const { cellSubCareer, classes } = this.props;
		if (cellSubCareer.length === 0) {
			return (
				<div className={this.props.classes.subComponent}>
					<Typography>{''}</Typography>
				</div>
			);
		}
		const subColumns = this.getSubColumns();
		return (
			<div className={this.props.classes.subComponent}>
				<ReactTable
					data={cellSubCareer}
					columns={subColumns}
					defaultPageSize={cellSubCareer.length}
					getTrProps={this.setRowColor(classes)}
					className="-striped -highlight"
					showPagination={false}
					showPaginationTop={false}
					showPaginationBottom={false}
				/>
				{this.state.functionMenus}
				<MessageDialog
					open={this.state.dialogOpen}
					showCancelButton={false}
					title={i18n.t('ProcessStatusSubTable_0001')}
					contents={[{ content: this.state.dialogMessage }]}
					onClose={this.handleCloseDialog}
					onClickOk={this.handleCloseDialog}
				/>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.state.certificationUploadDialog}
					onClose={this.handleCloseDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: classes.dialog,
					}}
				>
					<AppBar className={classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handleCloseDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('ProcessStatusSubTable_0002')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CertificationFileUpload
						careerID={this.state.careerID}
						classID={this.state.classID}
						seq={this.state.seq}
						reasonCode={this.state.reasonCode}
					/>
				</Dialog>
			</div>
		);
	}

	protected setRowColor = (classes: Record<string, string>) => (
		state: any,
		rowInfo: RowInfo
	) => {
		if (rowInfo === undefined) {
			return {};
		}

		let className: any = '';
		const Flg1: boolean =
			rowInfo.original.statusId === '4' &&
			rowInfo.original.careerTypeID === '90';
		const Flg2: boolean =
			(rowInfo.original.statusNum === 7 ||
				rowInfo.original.statusNum === 17) &&
			rowInfo.original.careerTypeID !== '90';
		if (Flg1 || Flg2) {
			if (rowInfo.index % 2 === 0) {
				className = classes.rowDarkColor;
			} else {
				className = classes.rowLightColor;
			}
		}

		return { className };
	};
	/**
	 * 全カラム定義取得
	 */
	protected getSubColumns(): any[] {
		const { classes } = this.props;
		return [
			{
				Cell: (row: RowRenderProps) => {
					return (
						<IconButton
							aria-label="More"
							aria-owns={
								this.state.functionMenus
									? 'long-menu'
									: undefined
							}
							aria-haspopup="true"
							data-index={row.index}
							onClick={this.handleOpenMenu()}
							className={classes.menuButton}
							size="small"
							disabled={this.props.adminView}
						>
							<MenuIcon />
						</IconButton>
					);
				},
				accessor: 'function',
				required: true,
				show: true,
				sortable: false,
				width: 40,
			},
			{
				Cell: (row: RowRenderProps) => {
					let careerType = row.value;
					if (
						careerType === 'eラーニング' ||
						careerType === '集合研修' ||
						careerType === '通信教育' ||
						careerType === 'カリキュラム'
					) {
						careerType = i18n.t(careerType, { ns: 'force' });
					} else if (careerType.substring(0, 4) === 'スキル:') {
						const skill = i18n.t('スキル', { ns: 'force' });
						let skillType = careerType.substring(
							4,
							careerType.length
						);
						if (
							skillType === '資格' ||
							skillType === '業務経験' ||
							skillType === 'スキル診断'
						) {
							skillType = i18n.t(skillType, { ns: 'force' });
						}
						careerType = skill + ':' + skillType;
					}
					return careerType;
				},
				Header: i18n.t('ProcessStatusSubTable_0003'),
				accessor: 'careerType',
				width: 150,
			},
			{
				Header: i18n.t('ProcessStatusSubTable_0004'),
				accessor: 'careerTitle',
				width: 300,
			},
			{
				Header: i18n.t('ProcessStatusSubTable_0005'),
				accessor: 'rankName',
				width: 150,
			},
			{
				Cell: (row: RowRenderProps) =>
					i18n.t(row.value, { ns: 'force' }),
				Header: i18n.t('ProcessStatusSubTable_0006'),
				accessor: 'isPriority',
				width: 150,
			},
			{
				Cell: (row: RowRenderProps) =>
					i18n.t(row.value, { ns: 'force' }),
				Header: i18n.t('ProcessStatusSubTable_0007'),
				accessor: 'status',
				width: 150,
			},
			{
				Header: i18n.t('ProcessStatusSubTable_0008'),
				accessor: 'complDate',
				width: 150,
			},
			{
				Header: i18n.t('ProcessStatusSubTable_0009'),
				accessor: 'validDate',
				width: 150,
			},
		];
	}

	/**
	 * メニューオープンハンドラ
	 */
	protected handleOpenMenu = () => (event: React.MouseEvent<HTMLElement>) => {
		const index = event.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			const rowData: ICellSubCareer = this.props.cellSubCareer[index];
			const functionMenus = this.getFunctionMenus(
				event.currentTarget,
				rowData
			);
			this.setState({ functionMenus });
		}
	};

	/**
	 * 行メニュー取得
	 * @param functionMenuAnchorEl アンカー要素
	 * @param rowData 行情報
	 */
	protected getFunctionMenus(
		functionMenuAnchorEl: HTMLElement,
		rowData: ICellSubCareer
	) {
		if (rowData.careerTypeID !== '90') {
			return (
				<Menu
					anchorEl={functionMenuAnchorEl}
					open={true}
					onClose={this.handleCloseMenu}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}
					getContentAnchorEl={undefined}
					PaperProps={{
						style: {
							maxHeight: ITEM_HEIGHT * 4.5,
							width: 300,
						},
					}}
				>
					<MenuItem onClick={this.showDetail(rowData)}>
						{i18n.t('ProcessStatusSubTable_0010')}
					</MenuItem>
					{rowData.appChangeOkFlg && (
						<MenuItem onClick={this.showChangeApplication(rowData)}>
							{i18n.t('ProcessStatusSubTable_0011')}
						</MenuItem>
					)}
					{rowData.appCancelOkFlg && (
						<MenuItem onClick={this.showCancelApplication(rowData)}>
							{i18n.t('ProcessStatusSubTable_0012')}
						</MenuItem>
					)}
					{rowData.appResultOkFlg && (
						<MenuItem
							onClick={this.showActResultApplication(rowData)}
						>
							{i18n.t('ProcessStatusSubTable_0013')}
						</MenuItem>
					)}
					{rowData.lecCancelOkFlg && (
						<MenuItem onClick={this.showStCancel(rowData)}>
							{rowData.careerTypeID === '10'
								? i18n.t('ProcessStatusSubTable_0014')
								: i18n.t('ProcessStatusSubTable_0015')}
						</MenuItem>
					)}
					{rowData.taskReportOkFlg && (
						<MenuItem onClick={this.showExercise(rowData)}>
							{i18n.t('ProcessStatusSubTable_0016')}
						</MenuItem>
					)}
					{rowData.enqueteDispFlg && (
						<MenuItem onClick={this.showQuestionnaire(rowData)}>
							{i18n.t('ProcessStatusSubTable_0017')}
						</MenuItem>
					)}
					{rowData.appLectureOkFlg && (
						<MenuItem onClick={this.showApply(rowData)}>
							{rowData.careerTypeID === '10'
								? i18n.t('ProcessStatusSubTable_0018')
								: i18n.t('ProcessStatusSubTable_0019')}
						</MenuItem>
					)}
					{rowData.retakeOkFlg && (
						<MenuItem onClick={this.showApply(rowData)}>
							{i18n.t('ProcessStatusSubTable_0020')}
						</MenuItem>
					)}
					{rowData.referenceOkFlg && (
						<MenuItem
							onClick={this.showActResultReference(rowData)}
						>
							{i18n.t('ProcessStatusSubTable_0021')}
						</MenuItem>
					)}
					{rowData.certificateUploadFlg && (
						<MenuItem
							onClick={this.handCertificationUpload(rowData)}
						>
							{i18n.t('ProcessStatusSubTable_0022')}
						</MenuItem>
					)}
					{rowData.certificateDispFlg && (
						<MenuItem onClick={this.showComplCertificate(rowData)}>
							{rowData.careerTypeID === '10'
								? i18n.t('ProcessStatusSubTable_0023')
								: i18n.t('ProcessStatusSubTable_0024')}
						</MenuItem>
					)}
					{rowData.assessMentResultDispFlg && (
						<MenuItem
							onClick={this.handleOpenAssessmentResult(rowData)}
						>
							{i18n.t('ProcessStatusSubTable_0025')}
						</MenuItem>
					)}
					{rowData.careerTypeID === '1' && rowData.testFlg && (
						<MenuItem onClick={this.showHistory(rowData)}>
							{i18n.t('ProcessStatusSubTable_0026')}
						</MenuItem>
					)}
				</Menu>
			);
		} else {
			return (
				<Menu
					anchorEl={functionMenuAnchorEl}
					open={true}
					onClose={this.handleCloseMenu}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}
					getContentAnchorEl={undefined}
					PaperProps={{
						style: {
							maxHeight: ITEM_HEIGHT * 4.5,
							width: 200,
						},
					}}
				>
					<MenuItem onClick={this.handleShowContent(rowData)}>
						{i18n.t('ProcessStatusSubTable_0027')}
					</MenuItem>
					<MenuItem onClick={this.showDetail(rowData)}>
						{i18n.t('ProcessStatusSubTable_0010')}
					</MenuItem>
					{rowData.appLectureOkFlg && (
						<MenuItem onClick={this.showApply(rowData)}>
							{i18n.t('ProcessStatusSubTable_0019')}
						</MenuItem>
					)}
					{rowData.lecCancelOkFlg && (
						<MenuItem onClick={this.showStCancel(rowData)}>
							{i18n.t('ProcessStatusSubTable_0028')}
						</MenuItem>
					)}
					{rowData.appCancelOkFlg && (
						<MenuItem onClick={this.showCancelApplication(rowData)}>
							{i18n.t('ProcessStatusSubTable_0012')}
						</MenuItem>
					)}
				</Menu>
			);
		}
	}

	/**
	 * 詳細画面表示
	 * @param e イベントオブジェクト
	 */
	protected showDetail = (rowData: ICellSubCareer) => () => {
		const { careerID, careerTypeID } = rowData;
		if (careerTypeID !== '90') {
			if (careerTypeID === '10') {
				let to = Routes.getPath(Screens.PERSONAL_SKILL_DETAIL);
				to = to.replace(/\/:skill_id/, `/${rowData.careerID}`);
				this.props.pushHistory(to);
			} else {
				let to = Routes.getPath(Screens.PERSONAL_CAREER_DETAIL);
				to = to.replace(/\/:career_id/, `/${careerID}`);
				this.props.pushHistory(to);
			}
		} else {
			let to = Routes.getPath(Screens.PERSONAL_CURRICULUM_DETAIL);
			to = to.replace(/\/:curriculum_id/, `/${careerID}`);
			this.props.pushHistory(to);
		}
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 申請変更画面表示
	 * @param e イベントオブジェクト
	 */
	protected showChangeApplication = (rowData: ICellSubCareer) => () => {
		const { careerID, classID, careerTypeID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CHANGE);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistoryState(to, {
			caller: window.location.pathname,
			skillViewFlg: careerTypeID === '10',
		});
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 申請取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected showCancelApplication = (rowData: ICellSubCareer) => () => {
		const { aplType, careerID, classID, careerTypeID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CANCEL);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:apl_type/, `/${aplType}`);
		this.props.pushHistoryState(to, {
			caller: window.location.pathname,
			skillViewFlg: careerTypeID === '10',
		});
	};

	/**
	 * 実績申請画面表示
	 * @param e イベントオブジェクト
	 */
	protected showActResultApplication = (rowData: ICellSubCareer) => () => {
		const { appLectureOkFlg, careerID, classID, careerTypeID } = rowData;
		if (careerTypeID === '10' && appLectureOkFlg) {
			const to = Routes.getPath(Screens.PERSONAL_LECTURE_APPLICATION);
			this.props.pushHistoryState(to, {
				caller: window.location.pathname,
				careerType: '10',
				resultApply: true,
				targetCareerId: careerID,
			});
		} else {
			let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_APPLICATION);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:class_id/, `/${classID}`);
			to = to.replace(/\/:nittei_only_flg/, `/0`);
			this.props.pushHistoryState(to, {
				caller: window.location.pathname,
				skillViewFlg: careerTypeID === '10',
			});
		}
	};

	/**
	 * 受講取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected showStCancel = (rowData: ICellSubCareer) => () => {
		const { careerID, classID, careerTypeID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_LECTURE_CANCEL);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		if (careerTypeID === '90') {
			to = to.replace(/\/:curriculum_flg/, `/1`);
		} else {
			to = to.replace(/\/:curriculum_flg/, `/0`);
		}
		this.props.pushHistoryState(to, {
			caller: window.location.pathname,
			skillViewFlg: careerTypeID === '10',
		});
	};

	/**
	 * 課題提出画面表示
	 * @param e イベントオブジェクト
	 */
	protected showExercise = (rowData: ICellSubCareer) => () => {
		const { careerID, classID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_EXERCISE);
		to = to.replace(/\/:career_id\//, `/${careerID}/`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistoryState(to, {
			caller: window.location.pathname,
			outOfPeriodFlg: rowData.outOfPeriodFlg,
		});
	};

	/**
	 * アンケート回答画面表示
	 * @param e イベントオブジェクト
	 */
	protected showQuestionnaire = (rowData: ICellSubCareer) => () => {
		const { careerID, classID, outOfPeriodFlg } = rowData;
		let pathname = Routes.getPath(Screens.PERSONAL_QUESTIONNAIRE);
		pathname = pathname.replace(/\/:career_id\//, `/${careerID}/`);
		pathname = pathname.replace(/\/:class_id$/, `/${classID}`);
		this.props.pushHistoryState(pathname, {
			caller: window.location.pathname,
			outOfPeriodFlg,
			showTree: true,
		});
	};

	/**
	 * 受講申請画面表示（受講申請、再申請共通）
	 * @param e イベントオブジェクト
	 */
	protected showApply = (rowData: ICellSubCareer) => () => {
		const { careerID, careerTypeID } = rowData;
		const to = Routes.getPath(Screens.PERSONAL_LECTURE_APPLICATION);
		const state = {
			caller: window.location.pathname,
			careerType: careerTypeID,
			targetCareerId: careerID,
		};
		this.props.pushHistoryState(to, state);
	};

	/**
	 * 実績参照画面表示
	 * @param e イベントオブジェクト
	 */
	protected showActResultReference = (rowData: ICellSubCareer) => () => {
		const {
			careerID,
			classID,
			seq,
			statusNum,
			reasonCode,
			careerTypeID,
		} = rowData;
		let to = Routes.getPath(Screens.PERSONAL_ACT_RESULT_REFERENCE);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		to = to.replace(/\/:seq/, `/${seq}`);
		this.props.pushHistoryState(to, {
			imstatListStatusId: statusNum,
			reasonCode,
			skillViewFlg: careerTypeID === '10',
		});
	};

	/**
	 * 修了証明書表示
	 * @param e イベントオブジェクト
	 */
	protected showComplCertificate = (rowData: ICellSubCareer) => () => {
		const { careerID, classID, careerTypeID, reasonCode, seq } = rowData;
		const { userAttr } = this.props;
		if (careerTypeID === '10') {
			let url =
				Config.tsqPath + '/tsq/pkg/action/per/skillCertificate.action?';
			url = url + 'accessType=10';
			url = url + '&userId=' + userAttr.userId;
			url = url + '&careerID=' + careerID;
			url = url + '&classID=' + classID;
			url = url + '&reasonCode=' + reasonCode;
			url = url + '&seq=' + seq;
			window.open(url, '_blank');
		} else {
			let url =
				Config.tsqPath + '/tsq/pkg/action/per/certificate.action?';
			url = url + 'userId=' + userAttr.userId;
			url = url + '&locale=' + userAttr.locale;
			url = url + '&lang=' + userAttr.lang;
			url = url + '&careerID=' + careerID;
			url = url + '&accessType=10';
			window.open(url, '_blank');
		}
	};

	/**
	 * テスト履歴画面表示
	 * @param e イベントオブジェクト
	 */
	protected showHistory = (rowData: ICellSubCareer) => () => {
		const { careerID, classID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_TEST_QUESTIONNAIRE_HISTORY);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/${classID}`);
		this.props.pushHistory(to);
	};

	/**
	 * カリキュラム内容表示
	 * @param event イベントオブジェクト
	 */
	protected handleShowContent = (rowData: ICellSubCareer) => () => {
		const { careerID, statusId } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_CURRICULUM_CONTENT);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:cur_type/, `/${statusId === '4' ? '1' : '0'}`);
		this.props.pushHistory(to);
	};

	/**
	 * 認定証アップロード
	 * @param rowResult
	 */
	protected handCertificationUpload = (rowData: ICellSubCareer) => () => {
		const { careerID, classID, reasonCode, seq } = rowData;
		this.setState({
			careerID,
			certificationUploadDialog: true,
			classID,
			reasonCode,
			seq,
		});
	};

	/**
	 * アセスメント回答結果表示
	 */
	protected handleOpenAssessmentResult = (rowData: ICellSubCareer) => () => {
		const { careerID, classID, rankID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_ASSESSMENT_RESULT);
		to = to.replace(/\/:career_id\//, `/${careerID}/`);
		to = to.replace(/\/:class_id\//, `/${classID}/`);
		to = to.replace(/\/:rank_id/, `/${rankID}/`);
		this.props.pushHistory(to);
	};

	protected handleCloseDialog = () => {
		this.setState({
			careerID: '',
			certificationUploadDialog: false,
			classID: '',
		});
	};

	/**
	 * メニュークローズハンドラ
	 */
	protected handleCloseMenu = () => {
		this.setState({ functionMenus: undefined });
	};
}

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
});

export interface IProcessStatusSubTableProps {
	cellSubCareer: ICellSubCareer[];
	adminView: boolean;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IProcessStatusSubTableProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ProcessStatusSubTable);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/ProcessStatusSubTable.tsx